<template>
  <VDialog v-model="dialog" width="400px">
    <VCard>
      <VCardTitle
        class="d-flex"
        style="justify-content: space-between; border-bottom: 1px solid #dfe2e9"
      >
        <span class="headline">
          {{ contractItem.productName }}
        </span>
        <span @click="close" class="cursor-pointer">
          <vue-icon icon="newBoldCloseIcon" />
        </span>
      </VCardTitle>
      <VCardSubtitle
        v-if="status"
        class="mt-3 pb-0"
        :style="{
          color: statusColor,
        }"
      >
        <v-chip> {{ $t(`contractOmtkStatus.${contractItem.state}`) }}</v-chip>
      </VCardSubtitle>
      <VCardText>
        <VList dense class="pt-0">
          <VListItem class="px-0 pt-0">
            <VListItemContent>
              <VListItemTitle class="mt-2 column-list">
                <span class="label">{{ $t("typeProduct") }}</span>
                <span class="value">
                  {{
                    contractItem.productCategory
                      ? contractItem.productCategory[`name_${$i18n.locale}`]
                      : "Not Found"
                  }}</span
                >
              </VListItemTitle>
              <VListItemTitle
                class="mt-2 column-list"
                style="white-space: normal"
              >
                <span class="label"> {{ $t("attributes") }} </span>
                <span class="value mini-attribute-dotes">
                  {{ contractItem.description }}
                </span>
              </VListItemTitle>
              <VListItemTitle class="mt-2 column-list">
                <span class="label"> {{ $t("count") }}</span>
                <span class="value"
                  >{{ contractItem.count }}
                  {{ contractItem.unit_type_name }}</span
                >
              </VListItemTitle>
              <VListItemTitle class="mt-2 column-list">
                <span class="label">{{ $t("acceptedCount") }}</span>
                <span class="value">
                  {{ contractItem.acceptedCount }}
                  {{ contractItem.unit_type_name }}</span
                >
              </VListItemTitle>
              <VListItemTitle class="mt-2 column-list">
                <span class="label">
                  {{ $t("rejectedCount") }}
                </span>
                <span class="value">
                  {{ contractItem.rejectedCount }}
                  {{ contractItem.unit_type_name }}
                </span>
              </VListItemTitle>
            </VListItemContent>
          </VListItem>
          <VCheckbox
            dense
            hide-details
            class="mt-0 mb-2"
            :label="$t('selectAll')"
            @change="selectAll"
            v-if="showSelectedAll"
            v-model="isSelectedAll"
          />
          <div
            class="d-flex justify-space-between align-center"
            v-for="initiator in initiators"
            :key="initiator.id"
          >
            <VCheckbox
              :disabled="initiator.notificationSent"
              dense
              hide-details
              class="mt-0"
              :label="initiator.initiator"
              :value="initiator.initiatorId"
              v-model="selectedInitiators"
            />
            <div class="d-flex align-center">
              <VTooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <VBtn
                    v-bind="attrs"
                    v-on="on"
                    v-if="
                      !initiator.ozl &&
                      initiator.statusType !== INITIATOR_STATUS_TYPE.REJECTED &&
                      initiator.statusType !== INITIATOR_STATUS_TYPE.ACCEPTED
                    "
                    class="new_style"
                    @click="openChangeInitiatorDialog(initiator.id, true)"
                    ><VueIcon icon="newShareIcon"></VueIcon
                  ></VBtn>
                </template>
                <span>{{ $t("changeEmployee") }}</span>
              </VTooltip>
              <VTooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <VBtn
                    v-bind="attrs"
                    v-on="on"
                    v-if="
                      !initiator.ozl &&
                      initiator.statusType !== INITIATOR_STATUS_TYPE.ACCEPTED
                    "
                    class="new_style"
                    @click="
                      $refs.deleteInitiatorConfirmDialogRef.open(initiator.id)
                    "
                  >
                    <VueIcon icon="newTrashIcon"></VueIcon>
                  </VBtn>
                </template>
                <span>{{ $t("delete") }}</span>
              </VTooltip>

              <VueIcon
                v-if="initiator.statusType === INITIATOR_STATUS_TYPE.ACCEPTED"
                class="mt-3 mr-3"
                icon="checkIcon"
                fill="#68B833"
              ></VueIcon>
              <VBtn
                class="new_style"
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.REJECTED ||
                  initiator.statusType === INITIATOR_STATUS_TYPE.PART_ACCEPTED
                "
                @click="openShowItemDialog(initiator.id)"
              >
                <VueIcon icon="newEyeIcon"></VueIcon>
              </VBtn>
              <VueIcon
                v-if="initiator.statusType === INITIATOR_STATUS_TYPE.REJECTED"
                class="ml-2 mr-3 mt-3"
                width="12px"
                icon="cancelIcon"
                fill="#ee6565"
              ></VueIcon>

              <svg
                width="18px"
                viewBox="0 0 26.349 26.35"
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.WAITING &&
                  initiator.notificationSent
                "
                fill="#FDCC05"
              >
                <g>
                  <g>
                    <circle cx="13.792" cy="3.082" r="3.082" />
                    <circle cx="13.792" cy="24.501" r="1.849" />
                    <circle cx="6.219" cy="6.218" r="2.774" />
                    <circle cx="21.365" cy="21.363" r="1.541" />
                    <circle cx="3.082" cy="13.792" r="2.465" />
                    <circle cx="24.501" cy="13.791" r="1.232" />
                    <path
                      d="M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05
			C6.902,18.996,5.537,18.988,4.694,19.84z"
                    />
                    <circle cx="21.364" cy="6.218" r="0.924" />
                  </g>
                </g>
              </svg>

              <svg
                role="img"
                width="18"
                viewBox="0 0 17 16"
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.PART_ACCEPTED
                "
              >
                <g fill="#01617f">
                  <path
                    d="M9.392 1.049c-.349-.051-.562-.033-.925-.033c-4.095 0-7.424 3.334-7.424 7.43s3.329 7.431 7.424 7.431c4.094 0 7.423-3.335 7.423-7.431c0-.346.044-.598-.002-.929l-7.399.961l.903-7.429z"
                  ></path>
                  <path
                    d="M11.375.047l-.945 6.539l6.613-.928C16.638 2.764 14.314.466 11.375.047z"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
        </VList>

        <VBtn
          v-if="showPushBtn"
          class="mt-3"
          width="100%"
          color="primary"
          :disabled="notificationDidNotSendUsers.length === 0"
          @click="sendPushNotification"
          >{{ $t("sendPushNotification") }}</VBtn
        >
        <div class="mt-3">
          <div
            class="d-flex justify-space-between mb-3"
            v-if="statusNew && !showPushBtn && !pendingStatus"
          >
            <VBtn
              class="white--text"
              width="45%"
              color="green"
              @click="matched"
              >{{ $t("matched") }}</VBtn
            >
            <VBtn
              class="white--text"
              width="45%"
              color="error"
              @click="openDenyContractDialog(contractItem.id)"
              v-if="statusNew && !showPushBtn && !pendingStatus"
              >{{ $t("notCompatible") }}</VBtn
            >
          </div>
        </div>
      </VCardText>
    </VCard>
    <ChangeInitiatorDialog
      ref="changeInitiatorDialog"
      @updateInitiatorList="updateInitiatorList"
    ></ChangeInitiatorDialog>
    <ShowItemDialog ref="showItemDialogRef"></ShowItemDialog>
    <WarningDialog
      @apply="deleteInitiator"
      v-model="initiatorDeleteConfirmDialog"
      ref="deleteInitiatorConfirmDialogRef"
    />
    <DenyContractDialog
      ref="denyContractDialog"
      @updateTableData="updateTableData"
    ></DenyContractDialog>
    <ContractItemPartAcceptedDialog
      ref="partAcceptedDialog"
      @updateTableData="updateTableData"
    ></ContractItemPartAcceptedDialog>
    <PartitionAcceptedDialog
      ref="partitionAcceptedDialog"
      @updateTableData="updateTableData"
    ></PartitionAcceptedDialog>
  </VDialog>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";
import ChangeInitiatorDialog from "@/components/omtk/ChangeInitiatorDialog.vue";
import ShowItemDialog from "@/components/omtk/ShowItemDialog.vue";
import DenyContractDialog from "@/components/omtk/DenyContractDialog.vue";
import ContractItemPartAcceptedDialog from "@/components/omtk/ContractItemPartAcceptedDialog.vue";
import PartitionAcceptedDialog from "@/components/omtk/PartitionAcceptedDialog.vue";
import {
  INITIATOR_STATUS_TYPE,
  contractItemStatus,
} from "@/utils/constants.js";

const CONTRACT_ITEM = {
  id: null,
  state: null,
  acceptedCount: null,
  rejectedCount: null,
  productName: null,
  initiatorAcceptedCount: null,
  initiatorCount: null,
  productGroupName: null,
  productCategory: null,
  description: null,
  count: null,
  unit_type_name: null,
  contractId: null,
};
export default {
  name: "ContractItemDialog",
  data() {
    return {
      token: null,
      checkedAll: false,
      dialog: false,
      contractItem: {
        ...CONTRACT_ITEM,
      },
      /**
       * @typedef {Object} Initiator
       * @property {string} statusType
       *
       * @type Initiator[]
       */
      initiators: [],
      selectedInitiators: [],
      initiatorDeleteConfirmDialog: false,
      notificationSentUsers: {},
      isSelectedAll: false,
    };
  },
  components: {
    ShowItemDialog,
    WarningDialog,
    ChangeInitiatorDialog,
    DenyContractDialog,
    ContractItemPartAcceptedDialog,
    PartitionAcceptedDialog,
  },
  computed: {
    pendingStatus() {
      let isPending = this.initiators.filter(
        (item) => item.statusType === this.INITIATOR_STATUS_TYPE.WAITING
      );
      return isPending.length >= 1;
    },
    statusNew() {
      return this.contractItem.state === contractItemStatus.NEW;
    },
    showPushBtn() {
      return (
        this.initiators.length !==
        Object.keys(this.notificationSentUsers).length
      );
    },
    INITIATOR_STATUS_TYPE() {
      return INITIATOR_STATUS_TYPE;
    },
    notificationDidNotSendUsers() {
      return this.selectedInitiators.filter((item) => {
        return !this.notificationSentUsers[item];
      });
    },
    contractItemStatus() {
      return contractItemStatus;
    },
    showSelectedAll() {
      let enabledInitiators = this.initiators.filter(
        (item) => !item.notificationSent
      );
      return enabledInitiators.length > 1;
    },
    status() {
      switch (this.contractItem.state) {
        case this.contractItemStatus.CONTRACT_ITEM_ACCEPTED:
          return true;
        case this.contractItemStatus.CONTRACT_ITEM_REJECT:
          return true;
        case this.contractItemStatus.CONTRACT_ITEM_PART_ACCEPTED:
          return true;
        case this.contractItemStatus.CONTRACT_ITEM_PARTITION_ACCEPTED:
          return true;
        case this.contractItemStatus.NEW:
          return true;
        default:
          return false;
      }
    },
    statusColor() {
      switch (this.contractItem.state) {
        case this.contractItemStatus.CONTRACT_ITEM_ACCEPTED:
          return "#36C281";
        case this.contractItemStatus.CONTRACT_ITEM_REJECT:
          return "#ee6565";
        case this.contractItemStatus.CONTRACT_ITEM_PART_ACCEPTED:
          return "#FDCC05";
        case this.contractItemStatus.CONTRACT_ITEM_PARTITION_ACCEPTED:
          return "#FDCC05";
        case this.contractItemStatus.NEW:
          return "#01456A";
        default:
          return "#FDCC05";
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.isSelectedAll = false;
    },
  },
  methods: {
    async matched() {
      this.showLoading();
      try {
        await this.$http.post(
          `/contract/office/accept/omtk/${this.contractItem.id}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        this.setSuccess({ text: this.$t("successfullySent") });
        this.updateTableData();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async sendPushNotification() {
      this.showLoading();
      try {
        await this.$http.post("/notification/push/by-contract", {
          contractItemId: this.contractItem.id,
          userIds: this.notificationDidNotSendUsers,
        });
        this.setSuccess({ text: this.$t("successfullySent") });
        this.dialog = false;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openShowItemDialog(initiatorId) {
      const { showItemDialogRef } = this.$refs;
      if (showItemDialogRef) {
        showItemDialogRef.open(initiatorId);
      }
    },
    openChangeInitiatorDialog(initiatorId, isChangeInitiator) {
      const { changeInitiatorDialog } = this.$refs;
      if (changeInitiatorDialog) {
        changeInitiatorDialog.open(initiatorId, isChangeInitiator);
      }
    },
    openDenyContractDialog(contractItemId) {
      const { denyContractDialog } = this.$refs;
      if (denyContractDialog) {
        denyContractDialog.open(contractItemId);
      }
    },

    async deleteInitiator(id) {
      this.showLoading();
      try {
        await this.$http.delete("/user-agreement/delete-item", {
          data: {
            objectId: id,
            reason: "",
          },
        });
        this.setSuccess({ text: this.$t("successfullyDeleted") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    updateInitiatorList() {
      this.$emit("updateTableData");
    },
    updateTableData() {
      this.$emit("updateTableData");

      this.close();
    },
    selectAll(val) {
      if (val) {
        this.selectedInitiators = this.initiators.map(
          (item) => item.initiatorId
        );
      } else {
        this.selectedInitiators = [];
      }
    },
    close() {
      this.dialog = false;
    },
    open({
      id,
      contractId,
      state,
      rejectedCount,
      acceptedCount,
      productName,
      initiatorAcceptedCount,
      initiatorCount,
      productGroupName,
      productCategory,
      description,
      count,
      unit_type_name,
    }) {
      this.contractItem = {
        id,
        contractId,
        state,
        acceptedCount,
        rejectedCount,
        productName,
        initiatorAcceptedCount,
        initiatorCount,
        productGroupName,
        productCategory,
        description,
        count,
        unit_type_name,
      };
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-attribute-dotes {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
